import { useAppDispatch, useAppSelector } from "@/app/appStore";
import {
  AnnotationView,
  selectAnnotationView,
  selectIsEditable,
  setAnnotationView,
} from "@/entities/annotation";
import { ANNOTATION_TYPES } from "@/entities/annotation/model/consts";
import { Select } from "@radix-ui/themes";

const AnnotationViewSelector = () => {
  const dispatch = useAppDispatch();
  const annotationView = useAppSelector(selectAnnotationView);
  const isEditable = useAppSelector(selectIsEditable);
  const handleAnnotationViewChange = (view: AnnotationView) => {
    dispatch(setAnnotationView(view));
  };

  return (
    <Select.Root
      value={annotationView}
      size="1"
      disabled={isEditable}
      onValueChange={(view: AnnotationView) => handleAnnotationViewChange(view)}
    >
      <Select.Trigger className="annotation-view-selector" />
      <Select.Content position="popper">
        <Select.Group>
          <Select.Item value={ANNOTATION_TYPES.JOURNEY}>
            1. Journey Annotation
          </Select.Item>
          <Select.Item value={ANNOTATION_TYPES.TRANSACTION}>
            2. Journey Transaction Annotation
          </Select.Item>
          <Select.Item value={ANNOTATION_TYPES.TRACK_PERSISTENCE}>
            3. Track Persistence Annotation
          </Select.Item>
          <Select.Item value={ANNOTATION_TYPES.PROXIMITY}>
            4. Proximity Annotation
          </Select.Item>
          <Select.Item value={ANNOTATION_TYPES.PROXIMITY_TIME_RANGES}>
            5. Proximity Time Ranges Annotation
          </Select.Item>
        </Select.Group>
      </Select.Content>
    </Select.Root>
  );
};

export default AnnotationViewSelector;
